import { useEffect } from 'react';
import FJMobileCreationViewContainer from '../FJMainPreview/FJMobileCreationView/FJMobileCreationViewContainer';
import FJMobileHistoryContainer from '../FJMainPreview/FJMobileHistory/FJMobileHistoryContainer';
import FJMobileTextToImageEditContainer from './FJMobileTextToImageEdit/FJMobileTextToImageEditContainer';
import FJMobileTextToImagePresetContainer from './FJMobileTextToImagePreset/FJMobileTextToImagePresetContainer';
import FJActionTextToImage from '../../redux/action/FJActionTextToImage';
import { useDispatch } from 'react-redux';
import FJMobileFooterModalContainer from './FJMobileFooterModal/FJMobileFooterModalContainer';

const FJMobileTextToImage = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FJActionTextToImage.initTextToImageDataAction());
    }, [dispatch]);
    return (
        <>
            <FJMobileTextToImagePresetContainer />
            <FJMobileCreationViewContainer />
            <FJMobileTextToImageEditContainer />
            <FJMobileHistoryContainer />
            <FJMobileFooterModalContainer />
        </>
    );
};
export default FJMobileTextToImage;
